import { DockButton } from '~/components/dock-button';

export type TabId = 'map' | 'jobs' | 'deck' | 'op' | 'diag';

interface DockProps {
  active: TabId;
  alertOnMap?: boolean;
  onChange: (tab: TabId) => void;
}

/** Phase-0 dock layout. LOG is temporarily replaced by DIAG so the field-test
 *  build surfaces platform diagnostics in the same slot. Restore LOG once the
 *  iOS-tab-survival question is answered. */
export function Dock(props: DockProps) {
  return (
    <div class="dock safe-bottom">
      <DockButton
        icon="map"
        label="MAP"
        active={props.active === 'map'}
        tone="action"
        notify={props.alertOnMap && props.active !== 'map'}
        onClick={() => props.onChange('map')}
      />
      <DockButton
        icon="jobs"
        label="JOBS"
        active={props.active === 'jobs'}
        tone="data"
        onClick={() => props.onChange('jobs')}
      />
      <DockButton
        icon="deck"
        label="DECK"
        active={props.active === 'deck'}
        tone="action"
        onClick={() => props.onChange('deck')}
      />
      <DockButton
        icon="profile"
        label="OP"
        active={props.active === 'op'}
        tone="data"
        onClick={() => props.onChange('op')}
      />
      <DockButton
        icon="cpu"
        label="DIAG"
        active={props.active === 'diag'}
        tone="data"
        onClick={() => props.onChange('diag')}
      />
    </div>
  );
}
